import ar from './ar.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import zh from './zh.json';

export const defaultLocale = 'fr';

export const languages = {
	'ar': ar,
	'en': en,
	'es': es,
	'fr': fr,
	'zh': zh
};
